import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/core/app.state";
import { CatalogsService } from "../services/catalogs.services";
import { CommonService } from "src/app/shared/common.service";
import * as catalogsActions  from "./catalogs.actions"
import { catchError, finalize, map, mergeMap, of, switchMap, tap } from "rxjs";
import { APIResponse } from "src/app/core/models/api-response";
import { ICatalog } from "../models/catalogs.models";
import { AlertEnums } from "src/app/shared/enums/shared.enums";
import { IProduct } from "../../produits/models/products.models";
import { TranslateService } from "@ngx-translate/core";
import { MatDialog } from "@angular/material/dialog";

@Injectable()
export class CatalogsEffects {
  constructor(
    private actions$: Actions,
    public store: Store<AppState>,
    private catalogsServices: CatalogsService,
    private commonService: CommonService,
    private translateService: TranslateService
  ) { }


      // fetch All Catalogs
      FetchAllCatalogsEffect$ = createEffect(() =>
        this.actions$.pipe(
          ofType(catalogsActions.FetchAllCatalogs),
          tap(() => {
            this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: true }));
          }),
          switchMap(() =>
            this.catalogsServices.listAllCatalogs().pipe(
              map((res: APIResponse<ICatalog>) => catalogsActions.FetchAllCatalogsSuccess({ catalogs: res })),
              catchError(() => of(
                catalogsActions.FetchAllCatalogsError()
              )),
              finalize(() => {
                this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: false }));
              })
            )
          )
        )
      )

    // fetch Catalogs
    FetchCatalogsEffect$ = createEffect(() =>
      this.actions$.pipe(
        ofType(catalogsActions.FetchCatalogs),
        tap(() => {
          this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: true }));
        }),
        switchMap((action) =>
          this.catalogsServices.listCatalogs(
            action.page,
            action.filter,
            action.key,
            action.sort_by,
            action.sort_mode
          ).pipe(
            map((res: APIResponse<ICatalog>) => catalogsActions.FetchCatalogsSuccess({ catalogs: res })),
            catchError(() => of(
              catalogsActions.FetchCatalogsError()
            )),
            finalize(() => {
              this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: false }));
            })
          )
        ),
      )
    );

      // get Catalog by id
      GetCatalogByIdEffect$ = createEffect(() =>
        this.actions$.pipe(
          ofType(catalogsActions.GetCatalogById),
          tap(() => {
            this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: true }));
          }),
          switchMap((action) =>
            // Fetch catalog WITHOUT companies for better performance
            // Companies will be loaded separately via pagination in the component
            this.catalogsServices.getCatalogById(action.id, action.simplified, false).pipe(
              map((res: APIResponse<ICatalog>) => catalogsActions.GetCatalogByIdSuccess({ catalog: res.object! })),
              catchError(() => of(
                catalogsActions.GetCatalogByIdError()
              )),
              finalize(() => {
                this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: false }));
              })
            )
          ),
        )
      )

    // get Catalog Products
    GetCatalogProductsEffect$ = createEffect(() =>
      this.actions$.pipe(
        ofType(catalogsActions.GetCatalogProducts),
        tap(() => {
          this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: true }));
        }),
        switchMap((action) =>
          this.catalogsServices.GetCatalogProducts(
            action.id,
            action.page || 1,
            action.limit || 25,
            action.simplified,
            false
          ).pipe(
            map((res: APIResponse<IProduct>) => catalogsActions.GetCatalogProductsSuccess({
              products: res.data,
              metadata: res.metadata
            })),
            catchError(() => of(
              catalogsActions.GetCatalogProductsError()
            )),
            finalize(() => {
              this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: false }));
            })
          )
        ),
      )
    )

    // Load more Catalog Products (append mode for pagination)
    LoadMoreCatalogProductsEffect$ = createEffect(() =>
      this.actions$.pipe(
        ofType(catalogsActions.LoadMoreCatalogProducts),
        switchMap((action) =>
          this.catalogsServices.GetCatalogProducts(
            action.id,
            action.page,
            action.limit || 25
          ).pipe(
            map((res: APIResponse<IProduct>) => catalogsActions.LoadMoreCatalogProductsSuccess({
              products: res.data,
              metadata: res.metadata
            })),
            catchError(() => of(
              catalogsActions.GetCatalogProductsError()
            ))
          )
        ),
      )
    )


    // add Catalog
    AddCatalogEffect$ = createEffect(() =>
      this.actions$.pipe(
        ofType(catalogsActions.AddCatalog),
        tap(() => {
          this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: true }));
        }),
        switchMap((action) =>
          this.catalogsServices.addCatalog(action.catalog).pipe(
            map((res: APIResponse<ICatalog>) => catalogsActions.AddCatalogSuccess({ catalog: res.object })),
            tap(() => {
              this.commonService.showToast(
                this.translateService.instant(`alerts.${AlertEnums.catalogAddSuccess}`),
                'SUCCESS'
              );
            }),
            catchError(() => of(catalogsActions.AddCatalogError())),
            finalize(() => {
              this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: false }));
            })
          )
        ),
      )
    );

     // Add agent type catalog
    AddAgentCatalogEffect$ = createEffect(() =>
      this.actions$.pipe(
        ofType(catalogsActions.AddAgentCatalog),
        tap(() => {
          this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: true }));
        }),
        switchMap((action) =>
          // of({}).pipe(
          //   map(() => catalogsActions.AddAgentCatalogSuccess({ catalog: { ...action.catalog } })),
          //   tap(() => {
          //     this.commonService.showToast(
          //       this.translateService.instant(`alerts.${AlertEnums.catalogAddSuccess}`),
          //       'SUCCESS'
          //     );
          //   }),
          //   finalize(() => {
          //     this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: false }));
          //   })
          // )
          this.catalogsServices.addAgentCatalog(action.catalog).pipe(
            map((res: APIResponse<ICatalog>) => catalogsActions.AddAgentCatalogSuccess({ catalog: res.object })),
            tap(() => {
              this.commonService.showToast(
                this.translateService.instant(`alerts.${AlertEnums.catalogAddSuccess}`),
                'SUCCESS'
              );
            }),
            catchError(() =>
              of(
                catalogsActions.AddAgentCatalogError()
              )
            ),
            finalize(() => {
              this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: false }));
            })
          )
        ),
      )
    );

     // Add agent type catalog
     UpdateAgentCatalogEffect$ = createEffect(() =>
      this.actions$.pipe(
        ofType(catalogsActions.UpdateAgentCatalog),
        tap(() => {
          this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: true }));
        }),
        switchMap((action) =>
          this.catalogsServices.updateAgentCatalog(action.id, action.catalog).pipe(
            map((res: APIResponse<ICatalog>) => catalogsActions.UpdateAgentCatalogSuccess({ catalog: res.object })),
            tap(() => {
              this.commonService.showToast(
                this.translateService.instant(`alerts.${AlertEnums.catalogUpdateSuccess}`),
                'SUCCESS'
              );
            }),
            catchError(() =>
              of(
                catalogsActions.UpdateAgentCatalogError()
              )
            ),
            finalize(() => {
              this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: false }));
            })
          )
        ),
      )
    );

      // update Catalog
      UpdateCatalogEffect$ = createEffect(() =>
        this.actions$.pipe(
          ofType(catalogsActions.UpdateCatalog),
          tap(() => {
            this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: true }));
          }),
          switchMap((action) =>
            this.catalogsServices.updateCatalog(action.id, action.catalog).pipe(
              map((res: APIResponse<ICatalog>) => catalogsActions.UpdateCatalogSuccess({ catalog: res.object })),
              tap(() => {
                this.commonService.showToast(
                  this.translateService.instant(`alerts.${AlertEnums.catalogUpdateSuccess}`),
                  'SUCCESS'
                );
              }),
              // Let the global HttpErrorInterceptor display API validation errors.
              catchError(() => of(catalogsActions.UpdateCatalogError())),
              finalize(() => {
                this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: false }));
              })
            )
          ),
        )
      )

      // delete Catalog
      deleteCatalogEffect$ = createEffect(() =>
        this.actions$.pipe(
          ofType(catalogsActions.DeleteCatalog),
          tap(() => {
            this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: true }));
          }),
          switchMap((action) =>
            this.catalogsServices.deleteCatalog(action.id).pipe(
              map((res: APIResponse<ICatalog>) => catalogsActions.DeleteCatalogSuccess()),
              tap(() => {
                this.commonService.showToast(
                  this.translateService.instant(`alerts.${AlertEnums.catalogDeleteSuccess}`),
                  'SUCCESS'
                );
              }),
              catchError(() => of(catalogsActions.DeleteCatalogError())),
              finalize(() => {
                this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: false }));
              })
            )
          ),
        )
      )

      // delete multiple catalogs
      deleteCatalogsEffect$ = createEffect(() =>
        this.actions$.pipe(
          ofType(catalogsActions.DeleteCatalogs),
          tap(() => {
            this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: true }));
          }),
          switchMap((action) =>
            this.catalogsServices.deleteCatalogs(action.pricelist_ids).pipe(
              map((res: APIResponse<ICatalog>) => catalogsActions.DeleteCatalogsSuccess()),
              tap(() => {
                this.commonService.showToast(
                  this.translateService.instant(`alerts.${AlertEnums.catalogDeleteSuccess}`),
                  'SUCCESS'
                );
              }),
              catchError(() => of(catalogsActions.DeleteCatalogError())),
              finalize(() => {
                this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: false }));
              })
            )
          ),
        )
      )

  // fetch All Company Catalogs
  FetchAllCompanyCatalogsEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(catalogsActions.FetchAllCompanyCatalogsById),
      tap(() => {
        this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: true }));
      }),
      switchMap((action) =>
        this.catalogsServices.listAllCompanyCatalogsById(action.id).pipe(
          map((res: APIResponse<ICatalog>) => catalogsActions.FetchAllCompanyCatalogsByIdSuccess({ companyCatalogsById: res.data })),
          catchError(() => of(
            catalogsActions.FetchAllCompanyCatalogsByIdError()
          )),
          finalize(() => {
            this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: false }));
          })
        )
      ),
    )
  );

    // fetch Products By Company Catalogs
    FetchProductsByCompanyCatalogsEffect$ = createEffect(() =>
      this.actions$.pipe(
        ofType(catalogsActions.GetProductsCatalogCompanyById),
        tap(() => {
          this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: true }));
        }),
        switchMap((action) =>
          this.catalogsServices.getProductsByCompanyCatalogById(action.locationId, action.catalogId, action.orderId, action.page, action.limit).pipe(
            map((res: APIResponse<IProduct>) => catalogsActions.GetProductsCatalogCompanyByIddSuccess({ products: res.data })),
            catchError(() => of(
              catalogsActions.GetProductsCatalogCompanyByIddError()
            )),
            finalize(() => {
              this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: false }));
            })
          )
        ),
      )
    );

    // Share catalog
    ShareCatalogEffect$ = createEffect(() =>
      this.actions$.pipe(
        ofType(catalogsActions.ShareCatalog),
        tap(() => {
          this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: true }));
        }),
        switchMap((action) =>
          this.catalogsServices.shareCatalog(action.catalogId, action.data).pipe(
            map((res) => catalogsActions.ShareCatalogSuccess({ notifiedCount: action.data.locations_ids.length })),
            catchError((error) => of(
              catalogsActions.ShareCatalogError({ error: error.error })
            )),
            finalize(() => {
              this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: false }));
            })
          )
        ),
      )
      )

  // export catalogs
  exportCatalogs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(catalogsActions.ExportCatalogs),
      tap(() => {
        this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: true }));
      }),
      mergeMap((action) =>
        this.catalogsServices.exportCatalogs(action.filter, action.key).pipe(
          map((file) => {
            const fileURL = window.URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = fileURL;
            link.download = `Catalogs-${new Date().toLocaleString()}.xlsx`;
            link.click();
            return catalogsActions.ExportCatalogsSuccess();
          }),
          catchError((error) =>
            of(catalogsActions.ExportCatalogsError())
          ),
          finalize(() => {
            this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: false }));
          })
        )
      )
      )
    );

    // download catalog
    downloadCatalog$ = createEffect(() =>
      this.actions$.pipe(
        ofType(catalogsActions.DownloadCatalog),
        tap(() => {
          this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: true }));
        }),
        mergeMap((action) =>
          this.catalogsServices.downloadCatalog(action.id).pipe(
            map((file) => {
              const fileURL = window.URL.createObjectURL(file);
              const link = document.createElement('a');
              link.href = fileURL;
              link.download = `Catalogs-${new Date().toLocaleString()}.xlsx`;
              link.click();
              return catalogsActions.DownloadCatalogSuccess();
            }),
            catchError((error) => of(catalogsActions.DownloadCatalogError())),
            finalize(() => {
              this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: false }));
            })
          )
        )
      )
    );

    // download catalogs
    downloadCatalogs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(catalogsActions.DownloadCatalogs),
      tap(() => {
        this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: true }));
      }),
      mergeMap((action) =>
        this.catalogsServices.downloadCatalogs(
          action.page,
            action.filter,
            action.key,
            action.sort_by,
            action.sort_mode,
            action.pricelist_ids,
        ).pipe(
          map((file) => {
            const fileURL = window.URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = fileURL;
            link.download = `Catalogs-${new Date().toLocaleString()}.zip`;
            link.click();
            window.URL.revokeObjectURL(fileURL);
            return catalogsActions.DownloadCatalogsSuccess();
          }),
          catchError((error) =>
            of(catalogsActions.DownloadCatalogsError())
          ),
          finalize(() => {
            this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: false }));
          })
        )
      )
      )
    );

    // Get Catalog Audience (companies list with pagination)
    GetCatalogAudienceEffect$ = createEffect(() =>
      this.actions$.pipe(
        ofType(catalogsActions.GetCatalogAudience),
        tap(() => {
          this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: true }));
        }),
        switchMap((action) =>
          this.catalogsServices.getAudienceCompanies(
            action.page || 1,
            action.limit || 20,
            action.search,
            action.sortBy || 'name',
            action.sortMode || 'asc',
            undefined, // No subsidiary_id - get all companies
            action.pricelistId,
            action.filters
          ).pipe(
            map((res: any) => catalogsActions.GetCatalogAudienceSuccess({
              companies: res.data || res.object || [],
              metadata: res.metadata
            })),
            catchError(() => of(
              catalogsActions.GetCatalogAudienceError()
            )),
            finalize(() => {
              this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: false }));
            })
          )
        ),
      )
    );

    // Load more Catalog Audience (append mode for pagination)
    LoadMoreCatalogAudienceEffect$ = createEffect(() =>
      this.actions$.pipe(
        ofType(catalogsActions.LoadMoreCatalogAudience),
        switchMap((action) =>
          this.catalogsServices.getAudienceCompanies(
            action.page,
            action.limit || 20,
            action.search,
            action.sortBy || 'name',
            action.sortMode || 'asc',
            undefined, // No subsidiary_id - get all companies
            action.pricelistId,
            action.filters
          ).pipe(
            map((res: any) => catalogsActions.LoadMoreCatalogAudienceSuccess({
              companies: res.data || res.object || [],
              metadata: res.metadata
            })),
            catchError(() => of(
              catalogsActions.GetCatalogAudienceError()
            ))
          )
        ),
      )
    );
    
    // Get Available Companies (all companies list for selection)
    GetAvailableCompaniesEffect$ = createEffect(() =>
      this.actions$.pipe(
        ofType(catalogsActions.GetAvailableCompanies),
        tap(() => {
          this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: true }));
        }),
        switchMap((action) =>
          this.catalogsServices.getAudienceCompanies(
            action.page || 1,
            action.limit || 20,
            action.search,
            action.sortBy || 'name',
            action.sortMode || 'asc',
            action.subsidiary_id,
            undefined, // No pricelistId - get all companies
            action.filters
          ).pipe(
            map((res: any) => catalogsActions.GetAvailableCompaniesSuccess({
              companies: res.data || res.object || [],
              metadata: res.metadata
            })),
            catchError(() => of(
              catalogsActions.GetAvailableCompaniesError()
            )),
            finalize(() => {
              this.store.dispatch(catalogsActions.SetCatalogLoader({ isLoading: false }));
            })
          )
        ),
      )
    );

    // Load more Available Companies (append mode for pagination)
    LoadMoreAvailableCompaniesEffect$ = createEffect(() =>
      this.actions$.pipe(
        ofType(catalogsActions.LoadMoreAvailableCompanies),
        switchMap((action) =>
          this.catalogsServices.getAudienceCompanies(
            action.page,
            action.limit || 20,
            action.search,
            action.sortBy || 'name',
            action.sortMode || 'asc',
            action.subsidiary_id,
            undefined, // No pricelistId - get all companies
            action.filters
          ).pipe(
            map((res: any) => catalogsActions.LoadMoreAvailableCompaniesSuccess({
              companies: res.data || res.object || [],
              metadata: res.metadata
            })),
            catchError(() => of(
              catalogsActions.GetAvailableCompaniesError()
            ))
          )
        ),
      )
    );
}
